angular.module('dnecom')
    .directive('transactionTag', function() {
        return {
            scope: {
                status: '='
            },
            replace: true,
            template: '<span class="simple-tag simple-tag-small transaction-tag transaction-tag-{{ getStatus() }}">{{ getStatusName() }}</span>',
            link: function(scope) {
                scope.getStatusName = function() {
                    return scope.status.replace(/_/g, ' ');
                }

                scope.getStatus = function() {
                    return scope.status.replace('_', '-');
                }
            }
        };
    });
